import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { governmentOrganisationTypeOptions } from '../../helper'

export const Government = () => {
  return (
    <FormField
      id='GovType'
      label='Government organisation type'
      options={governmentOrganisationTypeOptions}
      type={FormFieldTypes.select}
    />
  )
}
